import * as types from './../types/types';
import { DEVURL } from '../../apis/envUrl';
import Api from '../../apis';
import { sortColumns } from '../../utils';

export const getWaveDetails = (projectid) => async (dispatch) => {
  // let userid = userInformation?.userid;
  // let userName = sessionStorage.getItem("username");
  dispatch({ type: 'GET_WAVE_DETAILS_REQUEST' });
  try {
    //here need to add url and pass PM name
    let headers = {
      'Content-Type': 'application/json',
      'Content-Language': 'en-US',
      'Access-Control-Allow-Origin': '*',
    };
    const api = new Api();
    const axiosInstance = await api.init({ headers });
    let urlString = `${DEVURL}/waveDetails/${projectid}`;

    const res = await axiosInstance({
      url: urlString,
      method: 'GET',
      data: null,
    });

    if (res?.data === null) {
      dispatch({
        type: types.GET_WAVE_DETAILS_ERROR,
        payload: 'No records found',
      });
    } else {
      if (res.status === 200) { 
        dispatch({
          type: types.GET_WAVE_DETAILS_SUCCESS,
          payload: res.data,
        });
      } else {
        dispatch({
          type: types.GET_WAVE_DETAILS_ERROR,
          payload: 'Project not found',
        });
      }
    }
  } catch (err) {
    console.error(err);
    dispatch({ type: types.GET_WAVE_DETAILS_ERROR, payload: err });
  }
};

